module.exports = __webpack_public_path__ + "static/media/the-enchantress-returns.8a29b769.jpg";